import React from "react";
import SearchBar from "../SearchBar/SearchBar";
import { Link } from "react-router-dom";
import style from "./navBar.module.css";


export default function NavBar() {
  
  return (
    <div className={style.nav}>
      <ul>
       
     
        <li>
          <Link to="/activity">CREATE ACTIVITY</Link>
        </li>
        
      </ul>
    </div>
  );
}
